var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgB2BInviteLogoFuzu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 74,
  height: 22,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#292929",
  d: "M13.643 6.107 16.67 0H.5v21.426h6.688v-5.972h7.553V9.482H7.188V6.107zM29.081 13.362c0 1.62-.932 2.53-2.163 2.53s-2.162-.91-2.162-2.53V0h-6.688v13.598c0 5.939 4.325 8.402 8.85 8.402s8.85-2.497 8.85-8.402V0h-6.687zM66.812 0v13.362c0 1.62-.931 2.53-2.162 2.53-1.232 0-2.163-.91-2.163-2.53V0h-6.688v13.598c0 5.939 4.325 8.402 8.85 8.402 4.526 0 8.851-2.497 8.851-8.402V0zM39.928 0l-3.094 6.107h7.32l-7.786 15.32h17.934v-6.074h-7.486L54.635 0z"
})));
export default SvgB2BInviteLogoFuzu;